import React, { useEffect, useState } from 'react';
import Page from '../../layout/Page';
import permissions from '../../constants/permissions';
import { Container } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearRetailerGroups,
    getRetailerGroupPage,
} from '../../redux/actions/retailer-group/retailer-group-actions';
import SfaTable from '../../components/datatable/Table';
import config from '../../constants/config';
import { clearSortDetails } from '../../components/datatable/actions';
import { useNavigate } from 'react-router';

const { RETAILER_GROUP_UPDATE, RETAILER_GROUP_CREATE } = config.ROUTE_URLS;
const RetailerGroupListPage = ({ history }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState({
        page: 0,
        size: 15,
        sort: [
            {
                direction: 'DESC',
                property: 'modifiedDate',
            },
        ],
        query: undefined,
    });

    useEffect(() => {
        return () => {
            dispatch(clearSortDetails());
        };
    }, [dispatch]);
    useEffect(() => {
        dispatch(getRetailerGroupPage(searchQuery));
        return () => {
            dispatch(clearRetailerGroups());
        };
    }, [searchQuery, dispatch]);
    const retailerGroupPage = useSelector(
        (state) => state.retailerGroup.retailerGroupPage,
    );

    const isLoading = useSelector((state) => state.retailerGroup.isLoading);
    const handleSelectTablePage = ({
        size,
        page,
        sortOrder,
        sortColumn,
        query,
    }) => {
        searchData(size, page, sortOrder, sortColumn, query);
    };

    const searchData = (size, page, sortOrder, sortColumn, query) => {
        const queryObject = query
            ? [
                  {
                      operator: 'or',
                      value: [
                          {
                              value: `%${query}%`,
                              operator: 'like',
                              property: 'name',
                          },
                          {
                              value: `%${query}%`,
                              operator: 'like',
                              property: 'jurisdictionCode',
                          },
                      ],
                  },
              ]
            : undefined;

        const sort =
            sortOrder && sortColumn
                ? [
                      {
                          direction: sortOrder.toUpperCase(),
                          property: sortColumn,
                      },
                  ]
                : [
                      {
                          direction: 'DESC',
                          property: 'modifiedDate',
                      },
                  ];

        setSearchQuery({
            page: page < 1 ? 0 : page - 1,
            size,
            sort: sort,
            query: queryObject,
        });
    };

    const handleSearch = (query) => {
        searchData(
            retailerGroupPage.size,
            0,
            retailerGroupPage?.sort ? [0].direction : undefined,
            retailerGroupPage?.sort ? [0].property : undefined,
            query,
        );
    };
    return (
        <Page
            name="RetailerGroupListPage"
            title="Retailer Groups"
            data-testid="RetailerGroupListPage"
            addButtonRoles={[permissions.CREATE_RETAILER_GROUP_LIST]}
            onAddButtonClick={() => {
                navigate(RETAILER_GROUP_CREATE);
            }}>
            <Container className={'data-section'}>
                <SfaTable
                    pagination
                    contentKey="id"
                    loading={isLoading}
                    content={retailerGroupPage?.content}
                    page={retailerGroupPage?.number}
                    size={retailerGroupPage?.size}
                    totalElements={retailerGroupPage?.totalElements}
                    totalPages={retailerGroupPage?.totalPages}
                    noDataMessage={'There are no Retailer groups.'}
                    selector={{
                        variables: ['id'],
                        path: RETAILER_GROUP_UPDATE,
                        callback: (p) => navigate(p),
                    }}
                    columns={[
                        {
                            name: 'name',
                            title: 'Group Name',
                            sortable: true,
                            searchable: true,
                        },
                        {
                            name: 'isActive',
                            title: 'Status',
                            sortable: true,
                            searchable: true,
                            formatter: (val) => {
                                return val ? 'Active' : 'Inactive';
                            },
                        },
                        {
                            name: 'jurisdictionCode',
                            title: 'Jurisdiction',
                            sortable: true,
                            searchable: true,
                        },
                        {
                            name: 'minFacings',
                            title: 'Facings',
                            sortable: true,
                            searchable: true,
                            formatter: (val, { maxFacings }) => {
                                return maxFacings
                                    ? `${val} - ${maxFacings}`
                                    : `${val}+`;
                            },
                        },
                    ]}
                    fetchData={handleSelectTablePage}
                    onSearch={handleSearch}
                />
            </Container>
        </Page>
    );
};
export default RetailerGroupListPage;
